module.exports = __webpack_public_path__ + "img/tutorial-cost-active.a0bea67c.png";